import axios from 'axios';

const NOTIFICATIONS_API = "https://signal.osoulworld.com/api/notifications/send";
 
// دالة عامة لإرسال إشعار
export const sendNotification = async (notifyPayload, token) => {
  try {
    await axios.post(NOTIFICATIONS_API, notifyPayload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: token ? `Bearer ${token}` : undefined,
      },
    });
  } catch (err) {
    console.error("Error sending notification:", err);
  }
};

// 🔔 إشعار تسجيل الدخول
export const sendLoginNotification = (user) => {
  const payload = {
    event_name: "user_logged_in",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs",
    payload: { username: user.firstName || user.name }
  };
  return sendNotification(payload, user.access);
};

// 🔔 إشعار التسجيل
export const sendRegisterNotification = (user) => {
  const payload = {
    event_name: "user_registered",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs",
    payload: { username: user.firstName || user.name }
  };
  return sendNotification(payload, user.access);
};

// 🔔 إشعار تذكير بتأكيد البريد الإلكتروني
export const sendEmailReminderNotification = (user) => {
  const payload = {
    event_name: "email_confirmation_reminder",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs",
    payload: { username: user.firstName || user.name }
  };
  return sendNotification(payload, user.access);
};

// 🔔 إشعار الإعجاب بالملف
export const sendFileLikedNotification = (user, file) => {
  const likePayload = { like: true, file_name: file.name };

  const payload = {
    event_name: "file_liked",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs",
    payload: likePayload
  };

  return sendNotification(payload, user.access);
};


export const sendFileDownloadedNotification = (user, file) => {
  const payload = {
    event_name: "file_downloaded",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs.osoulworld",
    payload: { file_name: file.title || file.name }
  };

  return sendNotification(payload, user.access);
};


export const sendInsufficientBalanceNotification = (user, file) => {
  const payload = {
    event_name: "insufficient_balance",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs.osoulworld",
    payload: { file_name: file.title || file.name }
  };

  return sendNotification(payload, user.access);
};


// 🔔 إشعار تحفيز الاشتراك
export const sendSubscriptionIncentiveNotification = (user) => {
  const payload = {
    event_name: "subscription_incentive",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs.osoulworld",
    payload: {
      message: "Unlock premium features and enjoy unlimited access by subscribing today!"
    }
  };

  return sendNotification(payload, user.access);
};



// 🔔 إشعار أحدث العروض
export const sendLatestOffersNotification = (user) => {
  const payload = {
    event_name: "latest_offers",
    email: user.email,
    external_user_id: user.id,
    source_system: "gs.osoulworld",
    payload: {
      message: "Check out our latest offers and discounts available now!"
    }
  };

  return sendNotification(payload, user.access);
};
